// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1PIhW","search":"Settings_search__1xvvm","filter":"Settings_filter__25MaY"};